"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchBedroomGroupButtonV2({
  buttonProps = {},
  showActive = true,
  showInActive = true,
  text = "0",
}) {
  return (
    <Block className={"div-block-69"} tag={"div"}>
      {showInActive ? (
        <Link
          button={true}
          className={"bedroom-button"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          {text}
        </Link>
      ) : null}
      {showActive ? (
        <Link
          button={true}
          className={"bedroom-button active"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          {text}
        </Link>
      ) : null}
    </Block>
  );
}
